import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const labelVariants = cva('font-sans peer-disabled:cursor-not-allowed peer-disabled:opacity-70', {
  variants: {
    variant: {
      uppercase: 'text-label-md font-semibold uppercase tracking-label text-accent-ink',
      sentence: 'text-body-sm leading-none font-semibold text-accent-ink',
    },
  },
  defaultVariants: {
    variant: 'uppercase',
  },
});

export interface LabelProps
  extends
    React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>,
    VariantProps<typeof labelVariants> {}

const Label = React.forwardRef<React.ComponentRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, variant, ...props }, ref) => (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(labelVariants({ variant }), className)}
      {...props}
    />
  ),
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
